import { encodeSlug } from './encode-slug';
import { prefixLocale } from './prefix-locale';

export function buildChallengePath(slug: string, locale?: string): string {
  return prefixLocale(`/challenge/${encodeSlug(slug)}`, locale);
}
